import React from 'react';

import './Course.css';

const Course = () => {
  return (
    <div className='main-container-course'>
    
      <div className='container-course'>
          
              <div className="course-other">
        <div data-aos="fade-up"
     data-aos-duration="2000">

          <div className='course-table3'>
            <h1 className='thead3'>M.Tech</h1>  
            </div>
            <div data-aos="flip-down">
            <table className='table-style3'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Discipline</th>
                  <th>Intake Seats</th>
                  <th>Duration</th>
                 
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Computer Science & Engineering</td>
                  <td>24</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Civil Engineering</td>
                  <td>24</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Mechanical Engineering</td>
                  <td>24</td>
                  <td>2 Years</td>
                </tr>
               
              </tbody>
            </table>
          </div>
          </div>
        </div><hr />

     
        
      
        <div data-aos="fade-up"
        data-aos-duration="2000">
        <div className="course-btech">
          <div className='course-table1'>
            <h1 className='thead1' style={{color:"#134080"}}>B.Tech</h1>
            </div>
            <div data-aos="flip-down">
            <table className='table-style1'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Discipline</th>
                  <th>Total Seats</th>
                  <th>Duration </th>
                  <th>After LEET Exam Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Computer Science Engineering</td>
                  <td>60</td>
                  <td>4 Years</td>
                  <td>3 Years</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Civil Engineering</td>
                  <td>60</td>
                  <td>4 Years</td>
                  <td>3 Years</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Electrical Engineering</td>
                  <td>60</td>
                  <td>4 Years</td>
                  <td>3 Years</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Electronics & Communication Engineering</td>
                  <td>60</td>
                  <td>4 Years</td>
                  <td>3 Years</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Mechanical Engineering</td>
                  <td>120</td>
                  <td>4 Years</td>
                  <td>3 Years</td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
        </div>  

   
        <div className="course-diploma">
        <div data-aos="fade-up"
     data-aos-duration="2000">
          <div className='course-table2'>
            <h1 className='thead2'>Diploma</h1> 
            </div>
            <div data-aos="flip-down">
            <table className='table-style2'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Discipline</th>
                  <th>Total Seats</th>
                  <th>Duration After 10th</th>
                  <th>Duration After 12th</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Computer Science Engineering</td>
                  <td>60</td>
                  <td>3 Years</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Civil Engineering</td>
                  <td>60</td>
                  <td>3 Years</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Electrical Engineering</td>
                  <td>60</td>
                  <td>3 Years</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Electronics & Communication Engineering</td>
                  <td>60</td>
                  <td>3 Years</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>Mechanical Engineering</td>
                  <td>120</td>
                  <td>3 Years</td>
                  <td>2 Years</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>DMLT</td>
                  <td>60</td>
                  <td>3 Years</td>
                  <td>2 Years</td>
                </tr>
                <hr />
              </tbody> 
             
            </table>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Course;
